/* eslint-disable no-underscore-dangle, @typescript-eslint/ban-ts-comment */
// @ts-ignore
export const getInitialProps = () => window.__INITIAL_PROPS__;
